import React, { useState } from "react";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { timeDifferenceForDate } from "../utils";
import { useTheme, useThemeUpdate } from "../contexts/ThemeContext";
import PopupMenu from "../components/PopupMenu";
import { useNavigate } from "react-router-dom";
import "./PostGrid.css";
import { useMediaQuery } from "react-responsive";

import analyseIcon from "../icons/trending_up-24px.svg";
import SvgWebIcon from "../icons/iconComponents/WebIcon";
import SvgLinkIcon from "../icons/iconComponents/LinkIcon";
import SvgShareIcon from "../icons/iconComponents/ShareIcon";
import SvgNoteIcon from "../icons/iconComponents/Note";
import SvgBookmarkIcon from "../icons/iconComponents/Bookmark";
import { ShareModal } from "./Modal";
import FullSpanShareModal from "../components/FullSpanShareModal";

const PostGrid = (props) => {
    const theme = useTheme();
    const { is_premium, payment_status } = props.user;
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });
    const [isShareModalActive, setIsShareModalActive] = useState(false);

    const { isFullSpanShareModalActivated } =
        props.settings;

    function getBestValue(value, editedValue) {
        if (editedValue) {
            return editedValue;
        } else {
            return value;
        }
    }

    function onShareIconClick(e) {
        e.preventDefault();
        setIsShareModalActive(true);
        if (isSmallScreen) {
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(true, "isFullSpanShareModalActivated");
            });
        }
    }

    function onAnalyseNavButtonClick(e) {
        e.preventDefault();
        // setIsAnalyseModalActive(true);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");

            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue(e.currentTarget.dataset.title, "selectedAnayzeTitle");
            record.setValue(e.currentTarget.dataset.id, "selectedAnalyzePostId");
        });

        console.log(e.currentTarget.dataset.id);
        console.log(e.currentTarget.dataset.title);

        
        if (payment_status === "active" || payment_status === "trialing") {
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(!props.isActivated, "isRightNavActivated");
            });
        } else if (payment_status === "past_due") {
            navigate("/complete-payment");
        } else {
            navigate("/upgrade");
        }
    }
    return (
        <div className={`news-container-grid`}>
            {props.selectedPosts.edges.map((edge, index) => (
                <div className={`news-post-grid`} key={index}>
                    <div
                        id={edge.node.id}
                        className="news-item-grid"
                        key={edge.node.id}
                    >
                        <img
                            alt=""
                            className="post-image-grid"
                            src={edge.node.image_url}
                            loading="lazy"
                        />
                        <div className="news-headline-link-grid">
                            <h1
                                onClick={props.onHeadlineClick}
                                className={`news-headline-grid theme-${theme.foreground}`}
                                data-id={edge.node.id}
                                data-title={edge.node.title}
                                data-body={edge.node.body}
                                data-link={edge.node.link}
                                data-postid={edge.node.id}
                                data-img={edge.node.image_url}
                                data-html={edge.node.body_html}
                                data-source={getBestValue(
                                    edge.node.source.name,
                                    edge.node.source.edited_name
                                )}
                                data-created={edge.node.created}
                            >
                                {edge.node.title}
                            </h1>
                        </div>
                        <h3 className={`source-grid theme-${theme.paragraph}`}>
                            {getBestValue(
                                edge.node.source.name,
                                edge.node.source.edited_name
                            )}
                        </h3>
                        <h4 className={`created-grid theme-${theme.paragraph}`}>
                            {/* {c.created} */}
                            {timeDifferenceForDate(edge.node.created)}
                        </h4>
                        <p
                            className={`news-content-grid theme-${theme.paragraph}`}
                        >
                            {edge.node.body_short}
                        </p>

                        <div className="pop-up-menu-container-grid">
                            <div className="news-item-controls">
                                {/* <SvgNoteIcon size={18} /> */}
                                <div
                                    className="share-icon"
                                    onClick={onShareIconClick}
                                >
                                    <SvgShareIcon size={18} />
                                </div>
                                {/* <SvgWebIcon /> */}
                                {/* <SvgLinkIcon size={18} /> */}
                                {/* <SvgBookmarkIcon size={18} /> */}
                                <button
                                    data-title={edge.node.title}
                                    data-id={edge.node.id}
                                    onClick={onAnalyseNavButtonClick}
                                    className="analyse-button action-button my-sixth-step"
                                >
                                    <img src={analyseIcon} />
                                </button>
                            </div>

                            <PopupMenu
                                user={props.user}
                                settings={props.settings}
                                postId={edge.node.id}
                                isActivated={props.articleMenuActive}
                                postLink={edge.node.link}
                                postTitle={edge.node.title}
                                postBody={edge.node.body_short}
                            />

                        </div>
                    </div>

                </div>
            ))}
                            {isSmallScreen ? (
                                <div>
                                    {isShareModalActive ? (
                                        <div>
                                            {isFullSpanShareModalActivated ? (
                                                <div>
                                                    <FullSpanShareModal
                                                        postLink={
                                                            props.postLink
                                                        }
                                                        postTitle={
                                                            props.postTitle
                                                        }
                                                        isActivated={true}
                                                        user={props.user}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            ) : (
                                <div>
                                    {isShareModalActive ? (
                                        <div>
                                            <ShareModal
                                                title="Share"
                                                setIsModalActive={
                                                    setIsShareModalActive
                                                }
                                                isModalActive={
                                                    isShareModalActive
                                                }
                                                postLink={props.postLink}
                                                postTitle={props.postTitle}
                                                user={props.user}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            )}
        </div>
    );
};

export default PostGrid;
